import { Component, Inject, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogContent {
    description:string;
    title :string;
    bodyText:string;
    actionBtnText :string;
    isPrompt :boolean;
    showCheckBox :boolean;
    displayCloseBtn: boolean;
    showBtnGrp :boolean;
    shouldLogoutAllDevice:boolean;
    imgSrc: string;
}

@Component({
  selector: 'sita-dialog',
  standalone: false,
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent  {

    description:string = '';
    title = '';
    bodyText = ''
    actionBtnText = "";
    isPrompt = false;
    showCheckBox = false;
    displayCloseBtn = false;
    showBtnGrp = false;
    shouldLogoutAllDevice = true;
    imgSrc = ''

    @ViewChild('sessionCheckbox') checkbox!: MatCheckbox;

    constructor(
        private readonly dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data:any) {

        this.title = this.data.title;
        this.bodyText = this.data.bodyText;
        this.actionBtnText = this.data.actionBtnText;
        this.isPrompt = this.data.isPrompt;
        this.showCheckBox = this.data.showCheckBox ? this.data.showCheckBox: false;
        this.showBtnGrp = this.data.showBtnGrp ? this.data.showBtnGrp :false;
        this.displayCloseBtn = this.data.displayCloseBtn ? this.data.displayCloseBtn :false;

        if(this.isPrompt){
            setTimeout(() => this.close(), 2000)
        }
    }

    toggleDeviceLogout() {
        this.shouldLogoutAllDevice = ! this.shouldLogoutAllDevice;
    }

    save() {
        this.dialogRef.close("YES");
    }

    close() {
        this.showCheckBox ? this.dialogRef.close(this.checkbox?.checked): this.dialogRef.close()
    }
}
